import * as React from 'react';
import { CoreInput } from '../internal/WixUiCoreComponents/components/CoreInput';
import { st, classes } from './Input.st.css';
import { ErrorMessageWrapper } from '../ErrorMessageWrapper';
export const Input = (props) => {
    const { errorMessage, error, className, ...coreInputProps } = props;
    const { disabled } = props;
    return (React.createElement(ErrorMessageWrapper, { error: error, errorMessage: errorMessage, disabled: disabled, render: (errorProps) => (React.createElement(CoreInput, { className: st(classes.root, { error }, className), error: errorProps.error, ...coreInputProps })) }));
};
//# sourceMappingURL=Input.js.map